import { gql } from "@apollo/client"
import { CollectionMetadata, QueryCompanyArgs } from "@oysterhr/schema"
import { useQuery } from "@oysterhr/core"

const QUERY = gql`
  query PayrollGetCompanyEngagementTypes($companyId: ID!) {
    company(companyId: $companyId) {
      id
      contractors: engagements(
        engagementTypes: [CONTRACT]
        contractorsBillingTypes: [FIXED]
        states: [ENGAGED]
      ) {
        metadata {
          totalCount
        }
      }
      ftes: engagements(engagementTypes: [EMPLOYMENT], states: [ENGAGED]) {
        metadata {
          totalCount
        }
      }
      payrollTMs: engagements(engagementTypes: [PAYROLL], states: [ENGAGED]) {
        metadata {
          totalCount
        }
      }
    }
  }
`

type QueryResponse = {
  company: {
    contractors: { metadata: Pick<CollectionMetadata, "totalCount"> }
    ftes: { metadata: Pick<CollectionMetadata, "totalCount"> }
    payrollTMs: { metadata: Pick<CollectionMetadata, "totalCount"> }
  }
}

export const useCompanyEngagementTypes = ({
  variables,
  skip,
}: {
  variables: QueryCompanyArgs
  skip: boolean
}) => {
  const { data, loading } = useQuery<QueryResponse, QueryCompanyArgs>(QUERY, {
    fetchPolicy: "cache-first",
    variables,
    skip,
  })

  return {
    loading,
    hasOnlyFTEs:
      !!data?.company?.ftes?.metadata?.totalCount &&
      !data?.company?.contractors?.metadata?.totalCount &&
      !data?.company?.payrollTMs?.metadata?.totalCount,
  }
}
